export const parseParams = (params: any) => {
  const allParams: any = {};
  for (const [key, value] of new URLSearchParams(params).entries()) {
    allParams[key] = value;
  }
  return allParams;
};
